import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M24 31.75q-.3 0-.55-.1-.25-.1-.5-.35l-7.55-7.55q-.45-.45-.425-1.075.025-.625.475-1.075.45-.45 1.075-.45t1.075.45l4.9 4.95V9.5q0-.65.425-1.075Q23.35 8 24 8q.65 0 1.075.425.425.425.425 1.075v17.05l4.95-4.95q.45-.45 1.075-.45t1.075.45q.45.45.45 1.075t-.45 1.075l-7.55 7.55q-.25.25-.5.35-.25.1-.55.1ZM11 40q-1.2 0-2.1-.9Q8 38.2 8 37v-5.65q0-.65.425-1.075.425-.425 1.075-.425.65 0 1.075.425Q11 30.7 11 31.35V37h26v-5.65q0-.65.425-1.075.425-.425 1.075-.425.65 0 1.075.425Q40 30.7 40 31.35V37q0 1.2-.9 2.1-.9.9-2.1.9Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }